import React from 'react';
import { GrantDTO, GranTypeDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import { TableRow } from '../TableRow/TableRow';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency, formatNumber } from '../../../../CommonUtils/formatNumber';
import moment from 'moment';
import { DATE_FORMAT } from '../../../../CommonComponents/OPL/dates/utils';
import { OptionsPerGrantTypeDTO } from '../../api/useStockOptionsQuery';
import { ExerciseStrategyDTO } from '../../StockOptions.meta';

interface Props {
  grant: GrantDTO;
  options: OptionsPerGrantTypeDTO[];
}

export const VestingListTable = ({ grant, options }: Props) => {
  if ((grant.VestingList || []).length === 0) {
    return null;
  }

  const selectedGrant = options.find(item => item.GrantType === grant.GrantType);

  return (
    <table style={{ width: '100%', tableLayout: 'fixed' }}>
      <thead>
        <tr>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Vest Year
            </Text>
          </th>
          <th>
            <Text variant="smallCaps" textAlign="left">
              Shares to Vest
            </Text>
          </th>

          {(grant.GrantType === GranTypeDTO.Iso || grant.GrantType === GranTypeDTO.Nso) && (
            <>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Exercise Date
                </Text>
              </th>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Strike Price
                </Text>
              </th>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Expiration Date
                </Text>
              </th>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Shares to Exercise
                </Text>
              </th>
            </>
          )}

          {grant.GrantType === GranTypeDTO.Rsu && (
            <>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Shares Granted
                </Text>
              </th>
              <th>
                <Text variant="smallCaps" textAlign="left">
                  Shares Owned
                </Text>
              </th>
            </>
          )}
        </tr>
      </thead>

      <tbody>
        {grant.VestingList.map(vest => (
          <TableRow key={vest.Id}>
            <td>
              <Text fontWeight={500} textAlign="left">
                {moment.utc(vest.VestingDate).format('MM/DD/YYYY')}
              </Text>
            </td>
            <td>
              <Text variant="tabular" fontWeight={500} textAlign="left">
                {vest.VestedShares ? formatNumber(vest.VestedShares) : 0}
              </Text>
            </td>

            {(grant.GrantType === GranTypeDTO.Iso || grant.GrantType === GranTypeDTO.Nso) && (
              <>
                <td>
                  <Text fontWeight={500} textAlign="left">
                    {vest.ExerciseStrategy === ExerciseStrategyDTO.AtPrincipalRetirement ||
                    vest.ExerciseStrategy === ExerciseStrategyDTO.AtSpouseRetirement
                      ? selectedGrant?.AvailableExerciseOptions?.find(
                          opt => opt.Value === vest.ExerciseStrategy,
                        )?.Label
                      : vest.ExerciseDate
                      ? moment(vest.ExerciseDate).format(DATE_FORMAT)
                      : ''}
                  </Text>
                </td>
                <td>
                  <Text fontWeight={500} textAlign="left">
                    {vest.PricePerShare ? formatCurrency(vest.PricePerShare, { mantissa: 2 }) : ''}
                  </Text>
                </td>
                <td>
                  <Text fontWeight={500} textAlign="left">
                    {vest.ExpirationDate ? moment(vest.ExpirationDate).format(DATE_FORMAT) : ''}
                  </Text>
                </td>
                <td>
                  <Text variant="tabular" fontWeight={500} textAlign="left">
                    {formatNumber(vest.SharesToExercise)}
                  </Text>
                </td>
              </>
            )}
            {grant.GrantType === GranTypeDTO.Rsu && (
              <>
                <td>
                  <Text variant="tabular" fontWeight={500} textAlign="left">
                    {formatNumber(grant.TotalShares)}
                  </Text>
                </td>
                <td>
                  <Text variant="tabular" fontWeight={500} textAlign="left">
                    {formatNumber(vest.SharesOwned)}
                  </Text>
                </td>
              </>
            )}
          </TableRow>
        ))}
      </tbody>
    </table>
  );
};
